(function() { window.GUID_c10d8266_7a54_4068_a785_7cb225472274 = { getGuid: function() { return "c10d8266-7a54-4068-a785-7cb225472274"; } }; })();
var selectedEntityIdAutoComplete = $('#SelectedEntityIdAutoComplete');
$(function () {
    if (document.SelectedEntityId != null) {
        document.SelectedEntityId.FreezedElementScrollWhenOpen = $('#SearchResult');
        document.SelectedEntityId.SelectionChange = function () {
            selectedEntityIdAutoComplete.blur();
            var data = {};
            data.entityId = this.val();
            CompuSport.Ajax.Get(CSParameters.RUrl + "Account/UserCardPlayer/" + CSParameters.SportEventId, data, function (queryResult) {
                $('#UserCardContainer').html(queryResult);
            });
        };
    }
});

//# sourceMappingURL=UserCard.js.map
